<script setup lang="ts">
defineProps<{
  title: string
  subtitle?: string
}>()
</script>

<template>
  <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
    <div class="px-4 sm:px-0">
      <h2 class="text-base/7 font-semibold text-gray-900 dark:text-white">{{ title }}</h2>

      <p v-if="subtitle" class="mt-1 text-sm/6 text-gray-600 dark:text-zinc-400">{{ subtitle }}</p>
    </div>

    <form
      class="bg-white shadow-xs ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 dark:bg-zinc-800"
    >
      <div class="px-4 py-6 sm:p-8">
        <slot />
      </div>

      <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 p-4 sm:px-8">
        <slot name="actions" />
      </div>
    </form>
  </div>
</template>
